<template>
	<layout>
		<vForm @submit="login" v-bind="{err, message}">
			<vItem label="Email" v-bind="{error: errors.email}">
				<vInput type="email" v-model="form.email" required/>
			</vItem>
			<vItem label="Password" v-bind="{error: errors.email}">
				<vInput type="password" v-model="form.password" required/>
			</vItem>
			<div class="login">
				<btn tag="button" type="submit">Login</btn>
				<a class="forgot" @click="forgotPassword">Glemt din adgangskode?</a>
			</div>
		</vForm>
	</layout>
</template>

<script>
import {get} from "lodash";
import {vForm, vItem, vInput} from "@/components/form";
import btn from "@/components/button.vue";
import layout from "./layout.vue";

export default {
	components: {btn, layout, vForm, vItem, vInput},
	data() {
		return {
			err: {},
			message: "",

			form: {
				email: "",
				password: ""
			}
		}
	},
	computed: {
		errors: (t) => get(t.err, "errors", {})
	},
	methods: {
		reset() {
			this.message = "";
			this.err = {};
		},

		async login() {
			this.reset();

			try {
				await this.$store.dispatch("user/login", {form: this.form, route: "/"});
			} catch(err) {
				this.err = get(err, "response.data", {});
			}
		},

		async forgotPassword() {
			this.reset();

			try {
				const {data} = await this.$store.dispatch("user/forgotPassword", this.form);
				this.message = data.message;
			} catch(err) {
				this.err = get(err, "response.data", {});
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.login {
	margin-top: 60px;
	text-align: center;

	.button {
		width: 100%;
		text-transform: uppercase;
		height: 50px;
	}

	.forgot {
		display: inline-block;
		margin-top: 15px;
		font-size: 12px;
		color: #B1B1B1;
	}
}
</style>
